import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgParamRightAscension = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M18.3639 10.9399V5.63662H13.0606M18.3639 5.63662L5.63603 18.3645",
			stroke: "var(--stroke-0, #DFCBF5)",
			strokeOpacity: .7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgParamRightAscension;
